import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack, Typography, Box } from '@mui/material';
import KoriListItem from '@/components/KoriList/KoriListItem';

const KoriList = ({ data, loading, hasMore, loadMore }) => {
  const { ref, inView } = useInView({ threshold: 1 });
  const { t } = useTranslation();

  useEffect(() => {
    if (inView && hasMore && !loading) {
      loadMore();
    }
  }, [inView, hasMore, loading, loadMore]);

  return (
    <Stack>
      {data.length > 0 && (
        data.map(item => <KoriListItem key={item.id.id} item={item} />)
      )}
      { (data.length === 0 && !loading) && (
        <Typography display="flex" justifyContent="center" color="text.secondary">{t('koriList.noResults')}</Typography>
      )}
      <div ref={ref} style={{ height: '20px', width: '100%' }} />
      { loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress sx={{ display: 'flex', justifyContent: 'center' }} />
        </Box>
      )}
    </Stack>
  );
};

export default KoriList;
